import React from "react";

function OffeneWerkstat() {
    return (
        <div class="uk-container uk-padding">
            <h2>Offene Werkstatt</h2>
            <div class="uk-text-left">
                <h3>Werkstattbesuch</h3>
                <p>Möchtet Ihr die ganze Vielfalt meiner Handwerkskunst sehen? </p>
                <p>Ihr seid herzlich eingeladen, meine Werkstatt, nach telefonischer Absprache zu besuchen.</p>
                <p><b>04488 – 5204588</b></p>
                <br></br>

                <img class="uk-visible@m" src="/Adventszauber.jpg" alt="offenewerkstat" width="30% !important" /> 
                <img class="uk-hidden@m" src="/Adventszauber.jpg" alt="offenewerkstat" width="90% !important" />

                <br></br>

                <h3><u>Ältere Veranstaltungen</u></h3>

                <h3>Pfingsten <br></br>28.05. und 29.05.2023</h3>
                <p class="uk-margin-remove">So 28.05.2023 von 13 - 17 Uhr</p>
                <p class="uk-margin-remove">Mo 29.05.2023 von 13 - 17 Uhr</p>
                <h3>Tage des offenen Gartens</h3>
                <p class="uk-margin-remove">So 25.06.2023 von 11 - 18 Uhr</p>
                <p class="uk-margin-remove">So 13.08.2023 von 11 - 18 Uhr</p>
                <p>Tag des offenen Gartens mehr Infos hier: <a href="https://www.ammerland-touristik.de/">www.ammerland-touristik.de</a></p>
                <br></br>
            </div>
        </div>
    );
}

export default OffeneWerkstat;